module.exports = __webpack_public_path__ + "static/media/pic2.888a0a15.jpg";